export interface PageMetaTag {
  name: string;
  content: string;
}

export abstract class PageMetaTagsAdapter {
  abstract updateTitle(title: string): void;
  abstract updateTag(tag: PageMetaTag): void;
  abstract removeTag(name: string): void;
}
